import React from "react";
import { Outlet } from "react-router-dom";
import logo from "../../../Assets/Images/logo.png";

const PdfLayout = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="pdf-background">
    <div className='export-pdf-layout'>     
          <img src={logo} className="logo" alt="RV Park IQ"/>      
      <Outlet />
    </div>
    <div className="copy-rights export-copy">
        <p>
          © Copyright {currentYear} rvparkiq.com - All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default PdfLayout;
